// react
import { Layout, Menu, Popover } from 'antd'
import jwt_decode from 'jwt-decode'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { styled } from 'styled-components'
import { useAuth } from '../authContext'
import { MODAL_TYPES, useWizrModalContext } from '../providers/modal/WizrModalProvider'
import { dispatchCurrentModule, dispatchTenantDetails, dispatchupdateUserView } from '../redux/actions/content'
import { useGetCurrentModule, useGetTenantDetails } from '../redux/selectors/content'
import WizrAvatar from './WizrAvatar'
import WizrButton from './WizrButton'
import WizrFlexLayout from './WizrFlexLayout'
import WizrIcon from './WizrIcon'
import WizrText from './WizrText'

const { Sider } = Layout

const StyledSider = styled(Sider)`
  .ant-layout-sider-children {
    background: #fff;
    display: flex;
    ul {
      text-align: left;
      background: #fff;
      li {
        svg {
          height: 20px;
          width: 20px;
        }
        span {
          margin-left: 12px;
        }
      }
    }
    .ant-layout-sider-children .ant-layout {
      align-items: flex-start
    }

    .sampleIcon {
      height: 20px;
      width: 20px;
      background: #ccc;
      border-radius: 50px;
      margin-right: 5px;
      padding-left:6px;
    }

    .ant-avatar-circle {
      background-color: black;
      margin-left: 8px;
      height: 30px;
      width: 30px;
      span {
        margin-left: 0px;
      }
    }
  }
  padding: 20px 0px;
  background: #fff !important;
`
const StyledMenu = styled(Menu)`
  // Submenu items (children inside submenu) alignment
  .ant-menu-submenu .ant-menu-item {
    padding-left: 4px !important;
    margin-left: 0 !important;
    display: flex !important;
    align-items: center !important;
  }
  .ant-menu-submenu .ant-menu-item svg {
    margin-left: 0 !important;
    min-width: 20px;
    min-height: 20px;
    vertical-align: middle;
  }
  .ant-menu-submenu-popup,
  .ant-menu-submenu .ant-menu {
    background: transparent !important;
    transition: all 0.1s ease;
  }
  
  // Existing styles for selected states and submenu titles
  .ant-menu-submenu-selected .ant-menu-submenu-title {
    background: #e4e7ec !important;
    font-weight: 700;
    box-shadow: 0 2px 8px rgba(34, 34, 34, 0.04);
    span {
      font-weight: 700;
      color: #222 !important;
    }
    svg {
      path {
        stroke: #222 !important;
        transition: stroke 0.3s ease;
      }
    }
  }
  
  .ant-menu-item-selected {
    border-radius: 12px !important;
    background: #e4e7ec !important;
    font-weight: 700;
    box-shadow: 0 2px 8px rgba(34, 34, 34, 0.04);
    transition: all 0.3s ease;
    span {
      font-weight: 700;
      color: #222 !important;
    }
    svg {
      path {
        stroke: #222 !important;
        transition: stroke 0.3s ease;
      }
    }
  }
  
  // Prevent logout/user profile item from being highlighted and preserve avatar
  .ant-menu-item[data-menu-id*="logout"],
  .ant-menu-item-selected[data-menu-id*="logout"],
  .ant-menu-item[data-key="logout"],
  .ant-menu-item-selected[data-key="logout"] {
    background: transparent !important;
    box-shadow: none !important;
    font-weight: normal !important;
    
    span {
      font-weight: normal !important;
      color: inherit !important;
    }
    
    // Preserve avatar styling
    .ant-avatar,
    .ant-avatar-circle {
      background-color: black !important;
      color: white !important;
    }
  }
  
  // Also prevent Help and Notification items from being highlighted if needed
  .ant-menu-item[data-key="Help"],
  .ant-menu-item-selected[data-key="Help"],
  .ant-menu-item[data-key="notification"],
  .ant-menu-item-selected[data-key="notification"] {
    background: transparent !important;
    box-shadow: none !important;
    font-weight: normal !important;
    
    span {
      font-weight: normal !important;
      color: inherit !important;
    }
  }
  
  .ant-menu-submenu-open {
    position: relative;
    transition: all 0.3s ease;
  }
  
  .ant-menu-submenu-open::before {
    content: '';
    position: absolute;
    left: 38px;
    top: 55px;
    width: 2px;
    height: calc(100% - 65px);
    background: #d1d5db;
    border-radius: 1.5px;
    z-index: 0;
    transition: opacity 0.3s ease;
  }
  
  .ant-menu-submenu-open > .ant-menu {
    padding-left: 50px;
    margin: 2px 0 0 0;
    background: transparent;
    border-left: none;
  }
  
  .ant-menu-submenu:not(.ant-menu-submenu-open) > .ant-menu {
    padding-left: 50px;
    margin: 2px 0 0 0;
    background: transparent;
    border-left: none;
  }
  
  .ant-menu-item {
    border-radius: 12px !important;
    white-space: normal !important;
  }
  
  .ant-menu-title-content {
    white-space: normal !important;
    flex: none !important;
    margin-left: 12px !important;
  }
`
const StyledWizrButton = styled(WizrButton)`
  width: 30px;
  height: 40px;
`

const StyledDiv = styled.div`
  padding: 0px 20px;
  background: #fff;
`

const WizrUserSideBar = (): JSX.Element => {

  const { showModal, hideModal } = useWizrModalContext()
  const { filteredMenuItems } = useAuth()
  
  let data: any = null
  try {
    const token = localStorage.getItem('id_token')
    if (token && token !== 'null' && token !== 'undefined') {
      data = jwt_decode(token)
    }
  } catch (error) {
    console.error('Error decoding JWT token:', error)
    data = null
  }
  const key = useGetCurrentModule()
  const navigate = useNavigate()
  const location = useLocation()
  // const tenantDetails = useGetTenantDetails()

  const [active, setactive] = useState('')
  const [isSiderCollapsed, setIsSiderCollapsed] = useState(true)
  const [openKeys, setOpenKeys] = useState([]);
  const [logoutPopoverOpen, setLogoutPopoverOpen] = useState(false);

  useEffect(() => {
    setactive(key)
  }, [key])

  useEffect(() => {
    const login = location?.pathname?.includes('/login')
    const extension = location?.pathname?.includes('/extension')
    const sdlc = location?.pathname?.includes('/wizrsdlc')
    !login && !extension && !sdlc && dispatchTenantDetails()
  }, [])

   useEffect(() => {
    const pathname = location.pathname
    const currentPath = pathname.split('/')[1] || 'home'
    
    if (!key && currentPath && currentPath !== 'login' && currentPath !== 'extension' && currentPath !== 'wizrsdlc') {
      dispatchCurrentModule(currentPath)
    }
  }, [key, location.pathname])
  
  const tenantDetails = useGetTenantDetails() 

  const doNavigateToSection = (value: any) => {
    
     setactive(value.key)
    if (value.key === "controlroom") {
      navigate('/controlroom/dashboards')
    // } else if (value.key === "playwright") {
    //   window.location.href = 'https://wz-playwright-test-app-f2cnazaahubwcybf.eastus2-01.azurewebsites.net/'
    } else {
      dispatchCurrentModule(value.key)
      const originalEvent = value.domEvent;
      // Check if Ctrl key is pressed
      const isCtrlClick = originalEvent.ctrlKey;
      if (!isCtrlClick) {
        navigate(value?.navigateTo || value?.key)
      } else {
        const newPath = `/${value?.navigateTo || value?.key}`;
        const newUrl = `${window.location.origin}${newPath}`
        window.open(newUrl, '_blank');
      }
      dispatchupdateUserView({})
    }
  }

  const doSideMenuActions = (value: any) => {
    if (value.key === 'Help') {
      navigate('help')
    }
  }

  const showLogoutConfirm = () => {
    setLogoutPopoverOpen(false); // Close the popover when modal opens
    showModal(MODAL_TYPES.LOGOUT, {
      onLogoutConfirm: () => {
        localStorage.clear()
        sessionStorage.clear()
        window.location.href = '/login'
        hideModal()
      },
      onCancel: () => {
        hideModal()
        setLogoutPopoverOpen(false); // Ensure popover is closed when modal is cancelled
      },
    })
  }

  const getBottomMenuItems = () => {
    return [
      {
        key: 'Help',
        label: (<WizrFlexLayout flexDirection='row' alignItems='center' background='transparent'>
          <WizrText type='body2'>Help & Support</WizrText>
          {/* <WizrText type='captionItalic' textColor='#999B9F'> Coming Soon</WizrText> */}
        </WizrFlexLayout>),
        icon: <WizrIcon name='question' />,
      },
      // {
      //   key: 'notification',
      //   label: (<WizrFlexLayout flexDirection='row' alignItems='center' background='transparent'>
      //     <WizrText type='body2'>Notification</WizrText>
      //     <WizrText type='captionItalic' textColor='#999B9F'> Coming Soon</WizrText>
      //   </WizrFlexLayout>),
      //   icon: <WizrIcon name='bell' />,
      // },
      {
        key: 'logout',
        label: <WizrFlexLayout textAlign='left' style={{padding: '8px', overflow: 'auto', minHeight: '10px'}}>
        <WizrText type='body2'>{data ? (data as { name: string }).name : ''}</WizrText>
        <WizrText type='caption_medium'>{tenantDetails?.tenant_name}</WizrText>
        {/* <WizrText type='caption_normal'>varunsankarnair@gmail.com</WizrText> */}
        </WizrFlexLayout>,
        // <WizrText type='body2'>{(data as { name: string }).name}</WizrText>,
        icon: (
          <Popover
            trigger='click'
            open={logoutPopoverOpen}
            onOpenChange={setLogoutPopoverOpen}
            content={<WizrButton text='Logout' onClick={showLogoutConfirm} type='text' />}
          >
            <StyledWizrButton
              type='text'
              text={
                <WizrAvatar
                  name={data ? (data as { name: string }).name : ''}
                  background='transparent'
                  showText={false}
                  justifyContent='left'
                />
              }
            />
          </Popover>
        ),
      },
    ]
  }


  const onOpenChange = (keys: any) => {
    setOpenKeys(keys.slice(-1));
  };

  return (
    <StyledSider
      onMouseOver={() => setIsSiderCollapsed(false)}
      onMouseOut={() => setIsSiderCollapsed(true)}
      trigger={null}
      collapsible
      collapsed={isSiderCollapsed}
      //collapsed={false}
      onCollapse={(value) => setIsSiderCollapsed(value)}
      width={291}

    >
      <WizrFlexLayout justifyContent='space-between' background='#FFF' alignItems='flex-start'>
        <WizrFlexLayout background='#FFF' alignItems='flex-start'>
          <StyledDiv>
            {isSiderCollapsed ? <WizrIcon name='wizrlogo' /> : <WizrIcon name='wizrlogoText' />}
          </StyledDiv>
          <br />
          <StyledMenu
            openKeys={openKeys}
            onOpenChange={onOpenChange}
            theme='light'
            mode='inline'
            items={filteredMenuItems}
            selectable
            onClick={doNavigateToSection}
            selectedKeys={[active]}
          />
          <WizrFlexLayout justifyContent='flex-end' background='#FFF'>
            <StyledMenu
              theme='light'
              mode='inline'
              items={getBottomMenuItems()}
              selectable
              onClick={doSideMenuActions}
            />
          </WizrFlexLayout>
        </WizrFlexLayout>
      </WizrFlexLayout>
    </StyledSider>
  )
}

export default WizrUserSideBar